import GnlModulDTO from "src/models/Settings/Generals/GnlModulDTO";
import { ApiRequest } from "src/models/api.request";
import api from "src/services/core/api";

const controllerName = "GnlModulDTO";
const ModulTanimApi = api.injectEndpoints({
    endpoints: (builder) => ({
        ModulListesi: builder.query<Array<GnlModulDTO>, void>({
            query: (request) => {
                let api: ApiRequest<GnlModulDTO> = {
                    paging: false,
                    filters: {
                        groupOperator: "and",
                        predicates: []
                    },
                    sorts: [{ fieldName: "moduladi", ascending: true }]
                };
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: JSON.stringify(api)
                }
            }
        })
    })
});

export const {
    useModulListesiQuery
} = ModulTanimApi;